import React, { useEffect, useState } from "react";
import { Typography, Grid, Box, Card, TextField, InputAdornment, CardContent, Dialog, DialogContent, DialogActions, Button } from "@mui/material";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PercentIcon from "@mui/icons-material/Percent";
import moment from "moment";
import { logEventos } from "../../../services/services";
import Notify from "../../Notify";
import { postData, putData } from "../../../services/library";


export default function DialogActualizar(props) {
    const { datosExisten, open } = props;

    const style = {
        backgroundColor: "#ffffff",
        width: "100%",
    };

    const [datoslista, setDatoslista] = useState({
        id_producto: datosExisten.id_producto,
        precio_iva: "",
        precio_sin_iva: "",
        vigencia: "",
        usuario: localStorage.getItem('user'),
        fin_vigencia: ""
    });

    const [notificacion, setNotificacion] = useState({
        open: false,
        mensaje: "",
        severity: "",
        color: "",
    });

    const [porcentaje, setPorcentaje] = useState("");
    const [aumento, setAumento] = useState("");
    const [disbtn, setdisbtn] = useState(true);
    const fechaVigencia = moment(datoslista.vigencia);
    const fechaFinVigencia = fechaVigencia.subtract(1, "day");
    const fechaFinVigenciaPut = fechaFinVigencia.format("YYYY-MM-DD");

    const almacenar = (e) => {
        setDatoslista({
            ...datoslista,
            [e.target.name]: e.target.value,
        });
    };

    const handleActualizarPesos = (e) => {
        const nuevoAumento = e.target.value;
        setAumento(nuevoAumento);
        if (!isNaN(nuevoAumento) && nuevoAumento !== "") {
            setDatoslista({
                ...datoslista,
                precio_sin_iva: datosExisten.precio_sin_iva + parseFloat(nuevoAumento),
                precio_iva: datosExisten.precio_iva + parseFloat(nuevoAumento)
            })
        } else {
            setDatoslista({
                ...datoslista,
                precio_sin_iva: datosExisten.precio_sin_iva.toFixed(4),
                precio_iva: datosExisten.precio_iva.toFixed(4),
            });
        }
    };

    const handleActualizarPorcentaje = (e) => {
        const nuevoPorcentaje = e.target.value;
        setPorcentaje(nuevoPorcentaje);
        // setDesactivarPesos(nuevoPorcentaje !== "");  // Assuming you want to disable something based on the percentage

        if (!isNaN(nuevoPorcentaje) && nuevoPorcentaje !== "") {
            const porcentajeNumerico = parseFloat(nuevoPorcentaje) / 100;

            const nuevoPrecioSinIva = datosExisten.precio_sin_iva * (1 + porcentajeNumerico);
            const nuevoPrecioConIva = datosExisten.precio_iva * (1 + porcentajeNumerico);

            setDatoslista({
                ...datoslista,
                precio_sin_iva: nuevoPrecioSinIva.toFixed(4),
                precio_iva: nuevoPrecioConIva.toFixed(4),
            });
        } else {
            setDatoslista({
                ...datoslista,
                precio_sin_iva: datosExisten.precio_sin_iva.toFixed(4),
                precio_iva: datosExisten.precio_iva.toFixed(4),
            });
        }
    };


    useEffect(() => {
        //manejo el estado del boton -> si no hay un aumento en pesos o porcentaje que no se habilite el bton
        //despues tengo que manejar las validaciones: por ejemplo la fecha de  inicio vigencia no peude ser menor a la que está
        if ((!aumento && !porcentaje) || !datoslista.vigencia) {
            setdisbtn(true);
        } else {
            setdisbtn(false);
        }
    }, [aumento, porcentaje, datoslista.vigencia]);

    const handleClose = () => {
        open(false);
        props.actualizar();
        props.tabla(true);
    };

    const putPrecios = async (e) => {
        //cargo el nuevo precio
        postData(e, '/lista_precios/envasado',
            {
                id_producto: datosExisten.id_producto,
                precio_iva: datoslista.precio_iva,
                precio_sin_iva: datoslista.precio_sin_iva,
                usuario: datoslista.usuario,
                vigencia: datoslista.vigencia,
            },
            setNotificacion
        )
        //luego le pongo fecha de fin de vigencia a la lista 
        putData(e, `/lista_precios/envasado/${datosExisten.id_lista}`,
            {
                fin_vigencia: fechaFinVigenciaPut,
                usuario: localStorage.getItem('user')
            },
            setNotificacion
        )

        logEventos(
            "Guardar actualización del precio",
            "LISTA DE PRECIOS GRANEL",
            "Actualiza cierre de vigencia en pedido seleccionado y crea otro ",
            localStorage.getItem("user")
        );
    };


    return (
        <div>
            <Dialog open={open} fullWidth maxWidth="xl" onClose={handleClose}>
                {
                    datosExisten && (
                        <Box sx={{ padding: 2 }}>
                            <Card variant="outlined" sx={{ mb: 1, backgroundColor: "#F4F6F6" }}>
                                <CardContent>
                                    <Typography sx={{ fontSize: 19, mb: 2, textDecoration: "underline", textAlign: "center" }}>
                                        Precio Vigente
                                    </Typography>
                                    <Grid container spacing={1} alignItems="center" justifyContent="center">
                                        {[
                                            { label: "Precio sin IVA", value: datosExisten.precio_sin_iva || 0 },
                                            { label: "Precio con IVA", value: datosExisten.precio_iva || 0 },
                                        ].map((item, index) => (
                                            <Grid item xs={12} sm={6} md={4} key={index}>
                                                <TextField
                                                    fullWidth
                                                    style={style}
                                                    focused
                                                    size="small"
                                                    variant="outlined"
                                                    label={item.label}
                                                    value={`$` + (item.value).toFixed(4)}
                                                    InputProps={{ readOnly: true }}
                                                />
                                            </Grid>
                                        ))}
                                        <Grid item xs={12} sm={6} md={4}>
                                            <TextField
                                                fullWidth
                                                style={style}
                                                focused
                                                size="small"
                                                variant="outlined"
                                                label="Entrada en Vigencia"
                                                value={moment(datosExisten.vigencia).format("DD-MM-YYYY") || ""}
                                                InputProps={{ readOnly: true }}
                                            />
                                        </Grid>
                                    </Grid>

                                </CardContent>
                                <CardContent>
                                    <Typography sx={{ fontSize: 19, mb: 2, textDecoration: "underline", textAlign: "center" }}>
                                        Aumento
                                    </Typography>
                                    <Grid container spacing={1} alignItems="center" justifyContent="center">
                                        <Grid item xs={12} sm={6} md={2}>
                                            <TextField
                                                fullWidth
                                                style={style}
                                                focused
                                                size="small"
                                                color="secondary"
                                                label="Aumento en pesos"
                                                variant="outlined"
                                                type="number"
                                                value={aumento}
                                                onChange={handleActualizarPesos}
                                                disabled={porcentaje !== ""}
                                                InputProps={{
                                                    startAdornment: <InputAdornment position="start"><AttachMoneyIcon /></InputAdornment>,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={2}>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                style={style}
                                                focused
                                                type="number"
                                                color="secondary"
                                                label="Aumento en porcentaje"
                                                variant="outlined"
                                                value={porcentaje}
                                                onChange={handleActualizarPorcentaje}
                                                disabled={aumento !== ""}
                                                InputProps={{
                                                    startAdornment: <InputAdornment position="start"><PercentIcon /></InputAdornment>,
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </CardContent>
                                <CardContent>
                                    <Typography sx={{ fontSize: 19, mb: 2, textDecoration: "underline", textAlign: "center" }}>
                                        Precio Con Aumento
                                    </Typography>
                                    {/* Precios con aumento en un solo renglón */}
                                    <Grid container spacing={1} alignItems="center" justifyContent="center">
                                        {[
                                            { label: "Precio sin IVA", name: "precio_sin_iva", value: datoslista.precio_sin_iva || 0 },
                                            { label: "Precio con IVA", name: "precio_iva", value: datoslista.precio_iva || 0 },

                                        ].map((item, index) => (
                                            <Grid item xs={12} sm={6} md={4} key={index}>
                                                <TextField
                                                    fullWidth
                                                    style={style}
                                                    focused
                                                    size="small"
                                                    variant="outlined"
                                                    label={item.label}
                                                    name={item.name}
                                                    value={item.value}
                                                    onChange={almacenar}
                                                    InputProps={{ startAdornment: <InputAdornment position="start"><AttachMoneyIcon /></InputAdornment> }}
                                                />
                                            </Grid>
                                        ))}
                                        {/* Fecha Minima */}
                                        <Grid item xs={12} sm={6} md={4}>
                                            <TextField
                                                fullWidth
                                                style={style}
                                                focused
                                                size="small"
                                                variant="outlined"
                                                label="Fecha de entrada en vigencia"
                                                type="date"
                                                inputProps={{ min: moment(datosExisten.vigencia).format("YYYY-MM-DD") }}
                                                name="vigencia"
                                                value={datoslista.vigencia || ""}
                                                onChange={almacenar}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid
                                        container
                                        justifyContent="space-between"
                                        alignItems="flex-end"
                                        mt={2}
                                    >
                                        <Button variant="contained"
                                            onClick={() => open(false)}
                                            color="error">
                                            Volver
                                        </Button>

                                        <Button
                                            variant="contained"
                                            type="submit"
                                            color={"success"}
                                            onClick={putPrecios}
                                            disabled={disbtn}
                                        >
                                            Actualizar
                                        </Button>
                                    </Grid>
                                </CardContent>

                            </Card>
                        </Box>

                    )}
                {notificacion && notificacion.open ? (
                    <Notify
                        mensaje={notificacion.mensaje}
                        open={notificacion.open}
                        color={notificacion.color}
                        handleClose={handleClose}
                        severity={notificacion.severity}
                    />
                ) : null}
            </Dialog>
        </div>
    )
}